module.exports = __webpack_public_path__ + "img/2.d2800371.png";